<template>
    <section class="login py-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 mx-auto">
                    <img src="@/assets/images/ITA_Airways_Logo.svg" class="login-logo m-auto d-block" alt="" />
                    <h5 class="text-center mt-5">Quality observer</h5>
                    <nav class="mt-5">
                        <div class="nav nav-tabs" id="nav-tab" role="tablist">
                            <a
                                class="nav-item nav-link"
                                id="nav-login-tab"
                                data-toggle="tab"
                                href="javascript:;"
                                role="tab"
                                aria-controls="nav-login"
                                :aria-selected="currentTab === 'login'"
                                :class="{ active: currentTab === 'login' }"
                                @click="currentTab = 'login'"
                            >
                                Login
                            </a>
                            <!-- <a
                                class="nav-item nav-link"
                                id="nav-registration-tab"
                                data-toggle="tab"
                                href="javascript:;"
                                role="tab"
                                aria-controls="nav-registration"
                                :aria-selected="currentTab === 'registration'"
                                :class="{ active: currentTab === 'registration' }"
                                @click="currentTab = 'registration'"
                            >
                                Registrazione nuovo utente
                            </a> -->
                            <a
                                class="nav-item nav-link"
                                id="nav-password-recovery-tab"
                                data-toggle="tab"
                                href="javascript:;"
                                role="tab"
                                aria-controls="nav-password-recovery"
                                :aria-selected="currentTab === 'password-recovery'"
                                :class="{ active: currentTab === 'password-recovery' }"
                                @click="currentTab = 'password-recovery'"
                            >
                                Recupero password
                            </a>
                        </div>
                    </nav>
                    <div class="tab-content" id="nav-tabContent">
                        <div class="tab-pane fade" :class="{ 'show active': currentTab === 'login' }" id="nav-login" role="tabpanel" aria-labelledby="nav-login-tab">
                            <div class="card border-top-0">
                                <div class="card-header">
                                    Accedi con le tue credenziali.
                                </div>
                                <form v-on:submit.prevent="login">
                                <div class="card-body">
                                    <div class="form-group">
                                        <label for="InputUsername">Matricola</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <strong class="input-group-text">IT</strong>
                                            </div>
                                            <input required maxlength="6" id="InputUsername" type="text" v-model="username" class="form-control" placeholder="Numero matricola">
                                        </div>
                                        <small>Specifica <b>solo</b> il numero di matricola senza il prefisso <b>IT</b>. (es.: 123456)</small>
                                    </div>
                                    <div class="form-group mb-0">
                                        <label for="InputPassword">Password</label>
                                        <input required type="password" class="form-control" id="InputPassword" v-model="password" placeholder="Password" autocomplete="">
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <button class="btn btn-block btn-success">
                                        ACCEDI
                                    </button>
                                </div>
                                </form>
                            </div>
                            <div class="alert alert-danger" v-if="hasLoginErrors">
                                <span>Matricola o password errate.</span>
                                <!-- <span class="d-block" v-for="(error, i) in authErrors" :key="i">
                                    <b>{{ i.replace('username', 'matricola') }}</b> <span v-for="(e, ie) in error" :key="ie">{{ e }}<br/></span>
                                </span> -->
                            </div>
                        </div>
                        <div class="tab-pane fade" :class="{ 'show active': currentTab === 'registration' }" id="nav-registration" role="tabpanel" aria-labelledby="nav-registration-tab">
                            <div class="card border-top-0">
                                <div class="card-header">
                                    Registrazione nuovo utente.
                                </div>
                                <div class="card-body">
                                    <div class="form-group">
                                        <label for="InputNewEmail">Email *</label>
                                        <input type="email" class="form-control" id="InputNewEmail" v-model="newUserEmail" placeholder="Email">
                                    </div>
                                    <div class="form-group mb-0">
                                        <label for="InputNewUsername">Matricola *</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <strong class="input-group-text">IT</strong>
                                            </div>
                                            <input maxlength="6" id="InputNewUsername" type="text" v-model="newUsername" class="form-control" placeholder="Numero matricola">
                                        </div>
                                    </div>
                                    <small class="mt-3 d-block">* campi obbligatori</small>
                                </div>
                                <div class="card-footer">
                                    <button @click="registration" class="btn btn-block btn-success">
                                        REGISTRATI
                                    </button>
                                </div>
                            </div>
                            <!-- Client Errors -->
                            <div v-if="$v.$error" class="alert alert-danger mb-0">
                                <span v-if="!$v.newUserEmail.required || !$v.newUserEmail.email">Un indirizzo email valido è richiesta.<br></span>
                                <span v-if="!$v.newUsername.required">Il campo <i>Matricola</i> è richiesto.<br></span>
                                <span v-if="!$v.newUsername.minLength">Il campo <i>Matricola</i> dev'essere lungo 6 caratteri.<br></span>
                                <span v-if="!$v.newUsername.maxLength">Il campo <i>Matricola</i> dev'essere lungo 6 caratteri.<br></span>
                                <span v-if="!$v.newUsername.numeric">Il campo <i>Matricola</i> dev'essere un numero.<br></span>
                            </div>
                            <!-- Server Errors -->
                            <!-- <div class="alert alert-danger" v-if="hasRegistrationErrors">
                                <span class="d-block" v-for="(error, i) in registrationErrors" :key="i">
                                    <b>{{ i.replace('username', 'matricola') }}</b> <span v-for="(e, ie) in error" :key="ie">{{ e }}<br/></span>
                                </span>
                            </div> -->
                        </div>
                        <div class="tab-pane fade" :class="{ 'show active': currentTab === 'password-recovery' }" id="nav-password-recovery" role="tabpanel" aria-labelledby="nav-password-recovery-tab">
                            <div class="card border-top-0">
                                <div class="card-header">
                                    Hai dimenticato la password? Inserisci la tua matricola e te ne invieremo una temporanea.
                                </div>
                                <div class="card-body">
                                    <div class="form-group">
                                        <label for="InputRecoveryUsername">Matricola *</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <strong class="input-group-text">IT</strong>
                                            </div>
                                            <input maxlength="6" id="InputRecoveryUsername" type="text" v-model="recoveryUsername" class="form-control" placeholder="Numero matricola">
                                        </div>
                                    </div>
                                    <small class="d-block">Specifica <b>solo</b> il numero di matricola senza il prefisso <b>IT</b>. (es.: 123456)</small>
                                    <small class="mt-2 d-block">* campi obbligatori</small>
                                </div>
                                <div class="card-footer">
                                    <button @click="passwordRecovery" class="btn btn-block btn-success">
                                        RECUPERO PASSWORD
                                    </button>
                                </div>
                            </div>
                            <!-- Client Errors -->
                            <!--  -->
                            <!-- Server Errors -->
                            <!-- <div class="alert alert-danger" v-if="hasRegistrationErrors">
                                <span class="d-block" v-for="(error, i) in registrationErrors" :key="i">
                                    <b>{{ i.replace('username', 'matricola') }}</b> <span v-for="(e, ie) in error" :key="ie">{{ e }}<br/></span>
                                </span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {
    User
} from '@/models/User'
import {
    mapState
} from 'vuex'
import {
    CREATE,
    LOGIN,
    RECOVERY
} from '@/store/actions.type'
import {
    MODULE_NAME as USERS_MODULE_NAME
} from '@/store/modules/users.module'
import {
    email,
    maxLength,
    minLength,
    numeric,
    required
} from 'vuelidate/lib/validators'
export default {
    name: 'login',
    data () {
        return {
            currentTab: 'login',
            username: null,
            email: null,
            newUserEmail: null,
            newUsername: null,
            recoveryEmail: null,
            recoveryUsername: null,
            password: null,
            hasLoginErrors: false
        }
    },
    validations: {
        newUserEmail: {
            required,
            email
        },
        newUsername: {
            required,
            minLength: minLength(6),
            maxLength: maxLength(6),
            numeric
        }
    },
    methods: {
        login () {
            this.$store
                .dispatch(LOGIN, {
                    username: `IT${this.username}`,
                    password: this.password
                })
                .then(() => this.$router.push(this.nextPath))
                .catch(() => {
                    if ( this.authErrors.LOGIN ) {
                        this.hasLoginErrors = true;
                    }
                    // console.log(this.authErrors.LOGIN)
                })
        },
        registration () {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                let user = new User()
                user.username = `IT${this.newUsername}`
                user.email = this.newUserEmail
                this.$store.dispatch(`${USERS_MODULE_NAME}/${CREATE}`, user).then((data) => {
                    if (data.status === 200) {
                        this.$swal('Ben fatto!', 'Registrazione avvenuta con successo. Riceverai un messaggio con la procedura per terminare la registrazione, all\'indirizzo email utilizzato in fase di registrazione.')
                    }
                }).catch((e) => {
                    console.log(e.response)
                })
            }
        },
        passwordRecovery () {
            // this.$v.recoveryEmail.$touch()
            if (this.recoveryUsername) {
                this.$store
                    .dispatch(RECOVERY, {
                        username: `IT${this.recoveryUsername}`
                    })
                    .then(() => {
                        this.$swal('Ok!', 'Ti abbiamo inviato un\'email con le istruzioni per resettare la tua password!', 'success').then(() => {
                            location.reload()
                        })
                    })
                    .catch(() => {
                        this.$swal('Oooops!', 'Sembra che questa matricola non sia presente nel database!', 'warning')
                    })
            } else {
                this.$swal('Oooops!', 'Devi specificare una matricola!', 'warning')
            }
        }
    },
    computed: {
        ...mapState({
            authErrors: state => state.auth.errors,
            // registrationErrors: state => state.USERS.errors
        }),
        // hasLoginErrors () {
        //     return this.authErrors['LOGIN']
        // },
        // hasRegistrationErrors () {
        //     return Object.keys(this.registrationErrors).length !== 0 && this.registrationErrors.constructor === Object
        // },
        urlParams () {
            return this.$router.currentRoute.query
        },
        nextPath () {
            if (this.urlParams.surveyParams) {
                return {
                    path: `/survey?${this.urlParams.surveyParams}`
                }
            } else {
                return {
                    path: '/'
                }
            }
        }
    }
}
</script>
